import { IBaseTextBoxEditorProps, BaseTextBoxEditor } from "./BaseTextBoxEditor";

import { INumberTextBoxSpecificProps, NumberTextBox } from "./NumberTextBox";

import * as React from "react";

export interface IPercentageTextBoxEditorProps
    extends IBaseTextBoxEditorProps,
        INumberTextBoxSpecificProps,
        React.Props<PercentageTextBoxEditor> {
            valueLimit?:number
        }

export class PercentageTextBoxEditor extends BaseTextBoxEditor<IPercentageTextBoxEditorProps> {
    private _maxTextBoxLength = 20;

    constructor(props: IPercentageTextBoxEditorProps) {
        super(props);
    }

    protected getInput(): JSX.Element {
        return (
            <div className="">
                <div className="controls-percentage">
                    <NumberTextBox
                        {...(this.props as any)}
                        id={this.state.inputGroupId}
                        inputMode="numeric"
                        maxLength={this.props.maxLength || this._maxTextBoxLength}
                        onValidationResultChange={(
                            isValid: boolean,
                            errors: string[],
                            showValidationMessages: boolean
                        ) => this.handleValidationResultChange(isValid, errors, showValidationMessages)}
                        onBlur={(value) => this.onBlur(value)}
                    />
                    <span className="symbol">%</span>
                </div>
            </div>
        );
    }

    private onBlur(value: number): void {
        if(value > this.props.valueLimit)
        {
            const error = "Value must be less than or equal to " + this.props.valueLimit;
            this.handleValidationResultChange(false, [error], true);
            return;
        }
        else if (value > 999.99) {
            const error = "Value must be less than or equal to 999.99";
            this.handleValidationResultChange(false, [error], true);
            return;
        }
        
        if (this.props.onBlur) {
            this.props.onBlur(value);
        }

        this.setState({ typingFinished: true });
    }

    private handleValidationResultChange(isValid: boolean, errors: string[], showValidationMessages: boolean): void {
        this.onValidationResultChange(isValid, errors, showValidationMessages);

        if (this.props.onValidation) {
            this.props.onValidation(errors);
        }
    }
}
